require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-project-program-for-the-territorial-connectivity-and-integ.json") })
        }
      }, "path---en-us-project-program-for-the-territorial-connectivity-and-integ");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-project-program-for-the-territorial-connectivity-and-integ!./.cache/json/en-us-project-program-for-the-territorial-connectivity-and-integ.json
// module id = 553
// module chunks = 231608221292675